"use strict";

const IncidentEnforcementController = require("./incidentEnforcementController");
const BaseEnforcementAction = require("../../enforcement/baseEnforcementAction");

const EnforcementAction = function () {
  var getPropsFunction = function (data) {
    const openFindingsOptions = _getOpenFindingsOptions(data);
    return {
      levelOptions: FormSettings.getDropdownOptions("level", { tool: "indcom", sort: false }),
      enforcementReasonOptions: getEnforcementReasonOptions(data),
      openFindingsOptions,
      openFindings: data.openFindings,
    };
  };

  var getEnforcementReasonOptions = function (data) {
    const options = FormSettings.getDropdownOptions("enforcement-reason");

    return Object.keys(data?.openFindingsOptions ?? {})?.length === 0
      ? options.filter((option) => option.value !== "open-findings")
      : options;
  };

  var _getOpenFindingsOptions = function (data) {
    const grouped = new Map();
    (data.openFindingsOptions ?? []).forEach((openFinding) => {
      const investigation = data.incident?.investigations?.find((inv) => inv.id === openFinding.id);
      if (investigation) {
        const category = "Incident Investigations";
        if (!grouped.has(category)) {
          grouped.set(category, []);
        }
        const categoryList = grouped.get(category);
        categoryList.push({
          name: getOpenFindingDisplay(openFinding, investigation),
          value: openFinding.id,
        });
      }
    });
    return grouped;
  };

  var getOpenFindingDisplay = function (openFinding, investigation) {
    const displayDate = investigation?.displayInspectionDate || "Unknown Date";
    return `Investigation - ${displayDate}${openFinding.closed ? " (closed)" : ""}`;
  };

  const base = BaseEnforcementAction(IncidentEnforcementController, { getPropsFunction });

  return {
    ...base,
    getEnforcementReasonOptions,
    getOpenFindingDisplay,
    _getOpenFindingsOptions,
  };
};

module.exports = EnforcementAction();

const FormSettings = require("../../settings/formSettings");
